import WysiwygInput from './WysiwygInput.vue';

export default WysiwygInput;
